(() => {
  if (window.tsCardSwatchesInitialized) return;

  window.tsCardSwatchesInitialized = true;

  document.addEventListener(
    'click',
    (event) => {
      /*
       * =====================================
       * 1. カラースウォッチをクリック
       * =====================================
       */
      const swatch = event.target.closest('[data-ts-card-swatch]');

      if (swatch) {
        event.preventDefault();
        event.stopPropagation();

        if (swatch.disabled) return;

        const card = swatch.closest('.product-card-wrapper');

        if (!card) return;

        const image = card.querySelector(
          '.card__media .media > img:first-child'
        );

        const imageLink = card.querySelector(
          '[data-ts-card-image-link]'
        );

        const imageUrl = swatch.dataset.imageUrl;
        const imageAlt = swatch.dataset.imageAlt;
        const variantUrl = swatch.dataset.variantUrl;

        if (!image || !imageUrl) return;

        /*
         * 選択したカラーの商品画像へ変更
         */
        image.removeAttribute('srcset');
        image.src = imageUrl;

        if (imageAlt) {
          image.alt = imageAlt;
        }

        /*
         * 写真をクリックしたときのリンク先も
         * 選択したカラーのvariantへ変更
         */
        if (imageLink && variantUrl) {
          imageLink.href = variantUrl;
        }

        /*
         * カラー変更後はDawn標準の
         * 2枚目画像hover表示を停止
         */
        card.classList.add('ts-color-preview-active');

        /*
         * 選択中のスウォッチを更新
         */
        card
          .querySelectorAll('[data-ts-card-swatch]')
          .forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });

        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');

        return;
      }

      /*
       * =====================================
       * 2. 商品写真をクリック
       * =====================================
       */
      const imageLink = event.target.closest(
        '[data-ts-card-image-link]'
      );

      if (!imageLink) return;

      /*
       * Ctrl / Cmdクリックなどは
       * ブラウザ標準動作を残す
       */
      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const destination = imageLink.href;

      if (!destination) return;

      /*
       * 商品詳細ページへ移動
       */
      window.location.assign(destination);
    },
    true
  );
})();